import React, { Component } from 'react'
import { Field } from 'redux-form'
import Textarea from './textarea'

class TextAreaInput extends Component {
  render() {
    if (this.props.source) {
      return <Field label={this.props.label} component={Textarea} name={this.props.source} />
    } else {
      return <Textarea {...this.props} />
    }
  }
}

export default TextAreaInput
